export const CreateRouteConstant = {
  ON_EXIT_SCREEN_MESSAGE: "All changes will be discarded. Are you sure you want to leave this page?",
};
